import React from 'react';
import './EVLocateMe.scss';
import { checkURL, trackEvent } from 'helpers/Analytics';
import { getZipcode } from 'helpers/Zipgate';

interface IEVLocateMe {
  disable: boolean;
}

export function EVLocateMe({ disable }: IEVLocateMe): JSX.Element {
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  const trackingObject = isHonda
    ? { Page: { page_name: '' } }
    : window.Acr.trackingObject || {};
  const dspToken = sessionStorage.getItem('dsp_token');
  const buttonClass = isHonda ? '-honda' : '';
  const handleModal = () => {
    var event = new CustomEvent('react-zipgate-open', {
      detail: {
        hideCloseButton: false,
      },
    });
    window.dispatchEvent(event);
    if (!isHonda) {
      trackEvent({
        label: 'csl:locate me',
        category: {
          includePageName: false,
          text: 'csl:locate me',
        },
        type: 'selector',
        modelSeries: 'zdx',
        modelYear: '2024',
        bodyStyle: 'suvs',
        environment: checkURL(trackingObject.Page?.full_url || ''),
        locator: {
          Page: {
            ...trackingObject.Page,
            page_friendly_url: trackingObject.Page?.full_url || '',
          },
          User: {
            user_zipcode: getZipcode(),
            user_status: dspToken ? 'logged_in' : 'not_logged_in',
          },
          GlobalMetadata: {
            property_name: 'acura.com',
            version_dl: 'V1.0',
          },
        },
      });
    } else {
      trackEvent({
        label: 'csl:locate me',
        category: {
          includePageName: false,
          text: 'csl:locate me',
        },
        type: 'selector',
        modelSeries: 'zdx',
        modelYear: '2024',
        bodyStyle: 'suvs',
      });
    }
  };
  return (
    <div className="ev-locate-me">
      <button
        className={`ev-locate-me__button${buttonClass} acr-shadow-2`}
        onClick={handleModal}
        disabled={disable}
      />
    </div>
  );
}

export default EVLocateMe;
